import taskReducer from './reducers';

import * as taskActions from './actions';
import * as taskSelectors from './selectors';
import * as taskOperations from './operations';

export { taskActions, taskSelectors, taskOperations };

export default taskReducer;
